/**
 * Substitui o `AuthModal` do Dashboard mantendo EXATAMENTE a mesma interface, para que as páginas
 * migradas não precisassem ser tocadas.
 *
 * Aqui ele não é um modal: site estático não autentica. Abrir manda a pessoa para o app, que é
 * onde a sessão existe — "entrar" vai para a tela de entrada, "criar conta" vai para o processo
 * seletivo, que é fluxo autenticado (`POST /api/register`) e por isso continua no Dashboard.
 */
import { useEffect } from "react";
import { URL_ENTRAR, URL_PROCESSO_SELETIVO } from "@/lib/config";

interface AuthModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultTab?: "login" | "register";
}

export function AuthModal({ open, defaultTab = "login" }: AuthModalProps) {
  useEffect(() => {
    if (!open) return;
    window.location.href = defaultTab === "register" ? URL_PROCESSO_SELETIVO : URL_ENTRAR;
  }, [open, defaultTab]);

  // Nada é renderizado: a navegação já saiu desta página. Mesmo padrão do redirecionamento de
  // mesa branca no hts-site.
  return null;
}
